interface BuildEsimUrlParams {
  source: string
  path?: string
  token: string
  lang: string
}

// Keeps only real path segments: empty, `.` and `..` are dropped so the
// forwarded path cannot climb out of the eSIM service root.
const normalizeEsimPath = (path = '') =>
  path
    .split('/')
    .filter((segment) => segment && segment !== '.' && segment !== '..')
    .map((segment) => encodeURIComponent(segment))
    .join('/')

export const buildEsimUrl = ({
  source,
  path,
  token,
  lang,
}: BuildEsimUrlParams) => {
  const params = new URLSearchParams({ token, lang })

  return `${source}/${normalizeEsimPath(path)}?${params.toString()}`
}
